<template>
  <v-dialog v-model="show" :max-width="options.maxWidth" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable>
      <v-card class="background" max-height="480px">
        <v-toolbar color="primary" flat>
          <v-toolbar-title class="title">Admin upload</v-toolbar-title>
        </v-toolbar>

        <!-- Content -->
        <v-card-text class="card-text">

          <v-layout v-if="!edit" class="strd-card" column>

            <v-layout column outline class="mx-1 pa-2 border">
              <v-layout row>
                <span class="dialog-title">Status</span>
                <v-spacer/>
                <span class="status">{{ options.upload.status }}</span>
              </v-layout> 

              <v-layout row>
                <span class="dialog-sub-title">Mimetype</span>
                <v-spacer/>
                <span class="content">{{ options.upload.mimetype }}</span>
              </v-layout> 

              <v-layout row>
                <span class="dialog-sub-title">Type</span>
                <v-spacer/>
                <span class="content">{{ options.upload.type }}</span>
              </v-layout> 

          </v-layout> 

            <v-divider v-if="options.patient.firstName" class="dialog-divider"></v-divider>

            <v-layout v-if="options.patient.firstName" column outline class="mx-1 mb-2 pa-2 border">
              <v-layout row>
                <span class="dialog-title">Patient</span>
                <v-spacer/>
                <span class="content">{{ options.patient.firstName + " " + options.patient.lastName }}</span>
              </v-layout> 

              <v-layout row>
                <span class="dialog-sub-title">Birthdate</span>
                <v-spacer/>
                <span class="content">{{ convertDate(options.patient.birthdate) }}</span>
              </v-layout> 

              <v-layout row>
                <span class="dialog-sub-title">Phone number</span>
                <v-spacer/>
                <span class="content">{{ options.patient.phone }}</span>
              </v-layout> 

              <v-layout row>
                <span class="dialog-sub-title">Address</span>
                <v-spacer/>
                <span class="content">{{ options.patient.address.line1 + ", " + options.patient.address.city + " " + options.patient.address.zip}}</span>
              </v-layout> 
            </v-layout>             

        </v-layout>

        <!-- Editing -->
        <v-layout v-else class="strd-card" column>
          <v-form class="ma-2">

            <v-layout class="dialog-small-title">
              Status
            </v-layout>
            <v-select
              v-model="options.upload.status"
              :items="statuses"
              label="Status"
              solo
              flat
              class="form-input mb-2">
            </v-select>        

          </v-form>
        </v-layout>

        </v-card-text>
         
        <v-card-actions>
          <v-spacer/>
          <v-btn v-if="!edit" @click="clickEdit()" depressed color="primary">Edit</v-btn>
          <v-layout v-else row>
            <v-spacer/>
            <v-btn @click="cancelEdit()" flat color="primary">Cancel</v-btn>
            <v-btn @click="submit()" depressed color="primary">Submit</v-btn>
          </v-layout>
        </v-card-actions>

      </v-card>
    </v-dialog>
</template>

<style lang="scss" scoped>
@import '../../../styles/form';

.card > .card__actions {
  flex: none;
}

.card__actions .btn {
  text-transform: capitalize;
}

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 24px;
  font-weight: 300;
  line-height: 1.33;
  text-align: center;
  color: white;
}

.content {
  font-size: 14px;
  /* line-height: 22px; */
  font-weight: 300;
  color: #515151;
  text-align: right;
  line-height: 35px;
}

.dialog-title {
  font-size: 18px;
  line-height: 35px;
  font-weight: 500;
  color: #323232;
  margin-bottom: 5px;
}

.dialog-sub-title {
  font-size: 18px;
  line-height: 35px;
  font-weight: 350;
  color: #323232;
  margin-bottom: 5px;
}

.status {
  font-size: 14px;
  font-weight: 400;
  color: #515151;
  text-align: right;
  line-height: 35px;
}

.dialog-small-title {
  font-size: 14px;
  font-weight: 200;
  color: #515151;
  text-align: right;
  line-height: 35px;
}

.dialog-divider {
  width: 90%;
  margin-left: 5%;
}

.background {
  background-color: #fafafa;
}

.strd-card {
  border: 1px solid #e6e6e8;
  background-color: white;
}

// /deep/ .card__text {
//   padding-bottom: 0px;
// }
</style>

<script>
import Avatar from '@/core/components/Avatar'
import DialogMixin from '@/core/mixins/DialogMixin'
import FormTextarea from '@/core/components/FormTextarea'
import { mapActions } from 'vuex'

export default {
  name: 'OneConfirmDialog',
  mixins: [DialogMixin],
  components: {
    Avatar,
    FormTextarea
  },
  data() {
    return {
      upload: null,
      edit: false,
      status: null,
      patient: null,
      statuses: [
        'NOT_RECEIVED',
        'RECEIVED',
        'RENDERING_DICOM_READ',
        'NEEDS_ASSIGNMENT',
        'ERROR',
        'DONE'
      ],
      memo: null,
      fax: null,
      phone: null
    }
  },
  methods: {
    ...mapActions('admin', ['getPatient', 'setStatus', 'setProviderInfo']),
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    submit() {
      this.edit = !this.edit

      if (this.status !== this.options.upload.status) {
        this.setStatus({
          id: this.options.upload._id,
          status: { status: this.options.upload.status }
        })
      }
    },
    cancelEdit() {
      this.edit = !this.edit
      this.options.upload.status = this.status
    },
    clickEdit() {
      this.edit = !this.edit
      this.status = this.options.upload.status
    },
    onClose() {
      this.edit = false
    }
  },
  computed: {
    showBuilding() {
      return this.options.unit && this.options.building
    }
  },
  created() {
    this.$on('close', this.onClose)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/UploadDialog.vue